import { isSmallScreen } from '../../components/Game/src/isSmallScreen';
import { Viewport } from '../../lib/Viewport/Viewport';
export function viewPort() {
    var viewportProps = {
        minW: 300,
        minH: 600,
        debug: DEVELOPMENT && location.search.includes('viewPortDebug'),
    };
    var viewPort = new Viewport(viewportProps);
    viewPort.onChange(function () {
        document.body.classList.toggle('SmallScreen', isSmallScreen());
    });
    return viewPort;
}
